 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","about-us-about-us-module":"about-us-about-us-module","bedside-five-minute-bedside-five-minute-module":"bedside-five-minute-bedside-five-minute-module","bedside-five-minute-example-bedside-five-minute-example-module":"bedside-five-minute-example-bedside-five-minute-example-module","bedside-mini-chalk-example-bedside-mini-chalk-example-module":"bedside-mini-chalk-example-bedside-mini-chalk-example-module","bedside-mini-chalk-images-bedside-mini-chalk-images-module":"bedside-mini-chalk-images-bedside-mini-chalk-images-module","bedside-mini-chalk-talk-bedside-mini-chalk-talk-module":"bedside-mini-chalk-talk-bedside-mini-chalk-talk-module","bedside-tidbit-bedside-tidbit-module":"bedside-tidbit-bedside-tidbit-module","bedside-when-to-use-it-bedside-when-to-use-it-module":"bedside-when-to-use-it-bedside-when-to-use-it-module","clinical-teaching-five-step-example-clinical-teaching-five-step-example-module":"clinical-teaching-five-step-example-clinical-teaching-five-step-example-module","clinical-teaching-five-step-microskills-clinical-teaching-five-step-microskills-module":"clinical-teaching-five-step-microskills-clinical-teaching-five-step-microskills-module","clinical-teaching-mi-plan-clinical-teaching-mi-plan-module":"clinical-teaching-mi-plan-clinical-teaching-mi-plan-module","clinical-teaching-snapps-model-clinical-teaching-snapps-model-module":"clinical-teaching-snapps-model-clinical-teaching-snapps-model-module","clinical-teaching-snappsexample-clinical-teaching-snappsexample-module":"clinical-teaching-snappsexample-clinical-teaching-snappsexample-module","bedside-teaching-bedside-teaching-module":"bedside-teaching-bedside-teaching-module","clinical-teaching-clinical-teaching-module":"clinical-teaching-clinical-teaching-module","didactic-learning-didactic-learning-module":"didactic-learning-didactic-learning-module","feedback-feedback-module":"feedback-feedback-module","learner-differences-learner-differences-module":"learner-differences-learner-differences-module","core-js-js":"core-js-js","css-shim-3ea8955c-3ea8955c-js":"css-shim-3ea8955c-3ea8955c-js","css-shim-js":"css-shim-js","default~home-home-module~search-search-module":"default~home-home-module~search-search-module","home-home-module":"home-home-module","search-search-module":"search-search-module","dom-860d8016-860d8016-js":"dom-860d8016-860d8016-js","dom-js":"dom-js","effective-powerpoint-effective-powerpoint-module":"effective-powerpoint-effective-powerpoint-module","feedback-cast-feedback-cast-module":"feedback-cast-feedback-cast-module","feedback-four-step-model-feedback-four-step-model-module":"feedback-four-step-model-feedback-four-step-model-module","feedback-instant-formula-feedback-instant-formula-module":"feedback-instant-formula-feedback-instant-formula-module","feedback-methods-feedback-methods-module":"feedback-methods-feedback-methods-module","feedback-preparation-during-feedback-preparation-during-module":"feedback-preparation-during-feedback-preparation-during-module","feedback-preparation-feedback-preparation-module":"feedback-preparation-feedback-preparation-module","feedback-preparation-post-feedback-preparation-post-module":"feedback-preparation-post-feedback-preparation-post-module","feedback-preparation-pre-feedback-preparation-pre-module":"feedback-preparation-pre-feedback-preparation-pre-module","feedback-sample-email-feedback-sample-email-module":"feedback-sample-email-feedback-sample-email-module","feedback-smart-feedback-smart-module":"feedback-smart-feedback-smart-module","feedback-swag-feedback-swag-module":"feedback-swag-feedback-swag-module","feedback-types-feedback-types-module":"feedback-types-feedback-types-module","flipped-classroom-flipped-classroom-module":"flipped-classroom-flipped-classroom-module","index-d9adb105-js":"index-d9adb105-js","learner-differences-acgme-milestones-learner-differences-acgme-milestones-module":"learner-differences-acgme-milestones-learner-differences-acgme-milestones-module","learner-differences-activities-learner-differences-activities-module":"learner-differences-activities-learner-differences-activities-module","learner-differences-blooms-taxonomy-learner-differences-blooms-taxonomy-module":"learner-differences-blooms-taxonomy-learner-differences-blooms-taxonomy-module","learner-differences-complexity-learner-differences-complexity-module":"learner-differences-complexity-learner-differences-complexity-module","learner-differences-content-learner-differences-content-module":"learner-differences-content-learner-differences-content-module","learner-differences-epa-learner-differences-epa-module":"learner-differences-epa-learner-differences-epa-module","learner-differences-prime-learner-differences-prime-module":"learner-differences-prime-learner-differences-prime-module","references-references-module":"references-references-module","shadow-css-bbdf056f-05cd1ccb-js":"shadow-css-bbdf056f-05cd1ccb-js","ios-transition-3107e07c-js":"ios-transition-3107e07c-js","md-transition-90b00ffe-js":"md-transition-90b00ffe-js","swipe-back-ab1fb115-js":"swipe-back-ab1fb115-js","focus-visible-70161a50-js":"focus-visible-70161a50-js","hardware-back-button-08f20350-js":"hardware-back-button-08f20350-js","input-shims-09d70723-js":"input-shims-09d70723-js","status-tap-bdf48205-js":"status-tap-bdf48205-js","tap-click-b300ec79-js":"tap-click-b300ec79-js","swiper-bundle-a0ff558a-js":"swiper-bundle-a0ff558a-js"}[chunkId]||chunkId) + "-es5.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
